import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=316eb276&scoped=true"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316eb276",
  null
  
)

export default component.exports